import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { List } from 'antd'
import { Button } from 'ui/styled'
import PropTypes from 'prop-types'
import React from 'react'
import { getInitials } from 'utils/helpers'
import Cameo from '../../components/Cameo/Cameo'
import { ListItemCentered, ListItemMetaCentered } from './styled'

const ProviderList = ({ doctor_items = [], onEditDoctor, onRemoveDoctor }) => (
  <List>
    {doctor_items.map(item => {
      const initials = getInitials(item)
      const { image_url, id, full_name, navigator_notes } = item

      const getCameo = () => (
        <Cameo
          initials={initials}
          image_url={image_url}
          showCheckbox={false}
          border_color="#000"
        />
      )
      return (
        <ListItemCentered key={id}>
          <ListItemMetaCentered
            avatar={getCameo()}
            title={full_name}
            description={navigator_notes ? `"${navigator_notes}"` : ''}
          />
          <Button
            btntype="link"
            data-test="editProviderBtn"
            icon={<EditOutlined />}
            onClick={() => onEditDoctor(id)}
          >
            Edit
          </Button>
          <Button
            btntype="link"
            data-test="deleteProviderBtn"
            icon={<DeleteOutlined />}
            onClick={() => onRemoveDoctor({ id })}
          >
            Remove
          </Button>
        </ListItemCentered>
      )
    })}
  </List>
)

ProviderList.propTypes = {
  doctor_items: PropTypes.array,
  onRemoveDoctor: PropTypes.func.isRequired,
  onEditDoctor: PropTypes.func.isRequired
}

export default ProviderList
